
import React from "react";
import { useTheme } from "@material-ui/core";
import HvIconBase from "./IconBase";

const sizeSelector = (iconSize, height, width) => {
  if (height && width) {
    return { width, height };
  }

  switch (iconSize) {
    case "XS":
      return { width: 12, height: 12 };
    default:
    case "S":
      return { width: 16, height: 16 };
    case "M":
      return { width: 32, height: 32 };
    case "L":
      return { width: 96, height: 96 };
  }
};

const Fullscreen = ({
  color,
  iconSize = "S",
  viewbox = "0 0 16 16",
  height,
  width,
  semantic,
  inverted = false,
  svgProps,
  ...others
}) => {
  const theme = useTheme();
  const getColor = c => theme.palette?.[c] || c;
  const colorArray = 
    (typeof color === "string" && [getColor(color)]) ||
    (Array.isArray(color) && color.map?.(getColor)) ||
    [theme.palette.acce1];

  if (semantic) {
    colorArray[0] = theme.palette?.[semantic] || colorArray[0];
  }

  if (inverted && colorArray[1]) {
    colorArray[1] = colorArray[0];
    colorArray[0] = "none";
  }

  const size = sizeSelector(iconSize, height, width);

  return (
    <HvIconBase name="Fullscreen" iconSize={iconSize ?? "S"} {...others}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox={viewbox} height={size.height} width={size.width}   focusable={false} {...svgProps}>
  <path fill={colorArray[0]} className="color0"  d="M16 .0022v4.49829l-1.00006-.00012-.00006-2.79309-4.6463 4.64624-.7071-.707L14.293 1h-2.7934V0h4.49817v.00208zM4.50049 1l-.00006-1H.00226l.00006.00208L0 .0022V.707l.00006 3.79349 1-.00012.00006-2.79309 4.64636 4.64624.7071-.707L1.707 1zm10.49939 13.29272l-4.6463-4.64624-.7071.707L14.293 15h-2.7934v1h4.49817v-.0022H16v-4.49829h-1.00006zm-9.3534-4.64624l-4.64636 4.64624-.00006-2.79321h-1L0 15.293v.70483h.00232L.00226 16h4.49817l.00006-1H1.707l4.64655-4.64648z" />
</svg>
    </HvIconBase>
)};

Fullscreen.propTypes = HvIconBase.propTypes;

export default Fullscreen;